import React from 'react'
import PropTypes from 'prop-types'
import AlertContainer from 'react-alert'
import FileReplacePage from './FileReplacePage'
import { getFile, replaceFile, deleteFile } from '../../api/files'
import _ from 'lodash'

class FileReplacePageContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {
      location: null,
      tempFile: {},
      file: {},
      fileHash: Date.now(),
      isReplacing: false,
      isLoadingPreview: false,
      errorLoadingFile: false,
      errorLoadingPreview: false,
      isUploading: false,
      isImage: false,
      replaceModalIsOpen: false,
      progress: 0,
      overwritingFile: false,
      redirectToList: false
    }
  }

  _getFile = async (id) => {
    try {
      const file = await getFile({id})
      this.setState({file, isImage: file.mimeType.indexOf('image') > -1})
    } catch (err) {
      console.info(err)
      this.setState({errorLoadingFile: true})
    }
  }

  onSubmit = async (e) => {
    e.preventDefault()
    let errorMessage

    if (this.state.isUploading) {
      errorMessage = 'Uploading image please wait'
    } else if (this.state.isLoadingPreview) {
      errorMessage = 'Still loading image please wait'
    } else if (this.state.errorLoadingPreview) {
      errorMessage = 'Image URL not valid, cannot load'
    } else if (!this.state.location) {
      errorMessage = 'Please upload an image'
    }
    if (errorMessage) {
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
      return
    }

    if (this.state.overwritingFile) {
      this.setState({
        overwritingFile: false,
        isReplacing: false,
        location: '',
        replaceModalIsOpen: false,
        fileHash: Date.now()
      })
      let message = `Successfully replaced file`
      if (this.state.file.fileCount > 0) {
        message += ` across ${this.state.file.fileCount} pages`
      }
      this.msgSuccess.show(message, { type: 'success', time: 6000 })
      return
    }

    if (this.state.file.pages && this.state.file.pages.length) {
      let confirmMessage = `Replace ${this.state.file.fileCount} instances of the file across ${this.state.file.pages.length} pages? `
      confirmMessage += 'Caution: There is no "undo".'
      if (!confirm(confirmMessage)) {
        return
      }
    }

    this.setState({isReplacing: true})
    const id = this.state.file.id
    const tempFile = this.state.tempFile
    try {
      await replaceFile({id, tempFileId: tempFile.id})
      this.setState({isReplacing: false, location: '', replaceModalIsOpen: false})
      await this._getFile(id)
      let message = `Successfully replaced file`
      if (this.state.file.fileCount > 0) {
        message += ` across ${this.state.file.fileCount} pages`
      }
      this.msgSuccess.show(message, { type: 'success', time: 6000 })
    } catch (error) {
      console.info('error', error)
      const errorMessage = error.data ? error.data.message : 'An error occurred'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
      this.setState({isReplacing: false})
    }
  }

  loadImage = _.debounce((location) => {
    const image = new Image()
    image.onload = () => {
      this.setState({isLoadingPreview: false})
    }
    image.onerror = () => {
      this.setState({errorLoadingPreview: true, isLoadingPreview: false})
    }
    image.src = location
  }, 1000, {leading: true, trailing: true})

  loadFile = location => {
    this.setState({isLoadingPreview: false})
  }

  componentDidMount () {
    if (process.env.NODE_ENV !== 'test') {
      this._getFile(this.props.match.params.fileId)
    }
  }

  onKeyDown = (synthetic) => {
    // return
    if (synthetic.keyCode === 13) {
      this.onSubmit(synthetic)
    }
  }

  onDeleteFile = async (synthetic) => {
    const id = this.state.file.id
    try {
      await deleteFile(id)
      this.msgSuccess.show('Successfully deleted file', { type: 'success', time: 6000 })
      setTimeout(() => {
        this.setState({redirectToList: true})
      }, 5000)
    } catch (error) {
      console.info('error', error)
      const errorMessage = error.data ? error.data.message : 'Could not delete file'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
      this.setState({isReplacing: false})
    }
  }

  onStart = () => {
    this.setState({
      isUploading: true,
      progress: 0
    })
  }

  onGoBack = () => {
    this.props.history.goBack()
  }

  toggleReplaceModal = async () => {
    if (this.state.tempFile.id) {
      await deleteFile(this.state.tempFile.id)
    }
    this.setState({
      replaceModalIsOpen: !this.state.replaceModalIsOpen
    })
  }

  onFinish = async file => {
    if (this.state.tempFile.id) {
      await deleteFile(this.state.tempFile.id)
    }
    const location = file.location
    this.setState({
      isUploading: false,
      isLoadingPreview: true,
      errorLoadingPreview: false,
      tempFile: file,
      location
    })
    if (this.state.isImage) {
      this.loadImage(location)
    } else {
      this.loadFile(location)
    }
    console.info('file', file)
  }

  onError = error => {
    console.info('Error while uploading:', error)
    throw new Error(error.message || JSON.stringify(error, null, 2))
  }

  onFileExists = (file) => {
    if (this.state.file.originalName.split(' ').join('%20') !== file.name.split(' ').join('%20')) {
      const link = `${window.location.origin}/files/${file.id}/replace`
      alert(`File with file name "${file.originalName}" already exists. Go to ${link} to replace it.`)
      return false
    } else {
      const overwrite = confirm(`File with file name "${file.originalName}" already exists Do you want to overwrite it? This will replace all instances used in pages and cannot be undone.`)
      this.setState({overwritingFile: file.id})
      return overwrite
    }
  }

  render () {
    if (this.state.redirectToList) {
      this.props.history.goBack()
    }

    const dangerAlertOptions = {
      offset: 14,
      position: 'top right',
      theme: 'dark',
      time: 5000,
      transition: 'scale'
    }

    const successAlertOptions = {
      offset: 14,
      position: 'top right',
      theme: 'dark',
      time: 5000,
      transition: 'scale'
    }

    const methods = {
      onDeleteFile: this.onDeleteFile,
      onFinish: this.onFinish,
      onStart: this.onStart,
      onError: this.onError,
      onFileExists: this.onFileExists,
      onKeyDown: this.onKeyDown,
      onSubmit: this.onSubmit,
      toggleReplaceModal: this.toggleReplaceModal,
      onGoBack: this.onGoBack
    }

    return <div>
      <FileReplacePage
        {...methods}
        {...this.props} {...this.state} />
      <AlertContainer ref={a => (this.msg = a)} {...dangerAlertOptions} />
      <AlertContainer ref={a => (this.msgSuccess = a)} {...successAlertOptions} />
    </div>
  }
}

FileReplacePageContainer.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object
}

export default FileReplacePageContainer



// WEBPACK FOOTER //
// ./src/pages/FileReplacePage/FileReplacePageContainer.js